module.exports = __webpack_public_path__ + "static/media/grabit.3851d819.svg";